<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    convertedCustomers: any
    pagination: {
      currentPage: number
      lastPage: number
      total: number
      pageSize: number
    }
  }>(),
  {
    pagination: () => ({
      currentPage: 1,
      lastPage: 1,
      total: 0,
      pageSize: 15
    })
  }
)

const emit = defineEmits(['update:changePage'])

const { t } = useI18n()

const columns = {
  customer: {
    id: 'phone',
    label: t('pages.campaign.campaignDetailPage.tables.thead.customer')
  },
  checkinDate: {
    id: 'lastValidCheckinDate',
    label: t('pages.campaign.campaignDetailPage.tables.thead.convertedDatetime')
  },
  store: {
    label: t('pages.campaign.campaignDetailPage.tables.thead.store')
  }
}

const rows = computed(() => {
  return props.convertedCustomers.map((row) => {
    const customers = {
      id: row.customerId,
      data: {
        customer: {
          id: row.customerId,
          phone: row.customerPhone,
          name: row.customerFirstname,
          gender: row.customerGender,
          hasOptin: row.customerHasOptin,
          countryFlag: row.customerCountryFlag
        },
        checkinDate: {
          date: new Date(row.checkinDate).toLocaleDateString('fr-FR'),
          time: new Date(row.checkinDate).toLocaleTimeString('fr-FR')
        },
        store: row.storeName
      }
    }

    return customers
  })
})

const changePage = (page) => {
  emit('update:changePage', page)
}
</script>

<template>
  <AppTable
    :table-title="t('pages.campaign.campaignDetailPage.blocks.customerConverted.title')"
    :columns="columns"
    :rows="rows"
    :pagination="pagination"
    @update:change-page="changePage($event)"
  >
    <template #td-customer="{ data }">
      <RowCustomer
        :id="data.customer.id"
        :phone="data.customer.phone"
        :name="data.customer.name"
        :has-optin="data.customer.hasOptin"
        :country-flag="data.customer.countryFlag"
      />
    </template>

    <template #td-checkinDate="{ data }">
      <div class="flex flex-col">
        <div class="text-sm font-medium text-foreground">{{ data.checkinDate.date }}</div>
        <div class="text-sm text-muted-foreground">{{ data.checkinDate.time }}</div>
      </div>
    </template>

    <template #td-store="{ data }">
      <div class="text-sm font-medium text-foreground">{{ data.store }}</div>
    </template>
  </AppTable>
</template>
